import React from 'react';

import './style.scss';

const Download = ({ download }) => {
  const downloadTitle = download.get('title');
  const link = download.get('source');
  return (
    <a href={link} className="Download__wrapper">
      <div className="Download">
        <div className="Download__title icon-before icon-download">{downloadTitle}</div>
      </div>
    </a>
  );
};

export default Download;
